import _ from 'lodash'

import { strings, formatString } from '../context/LanguageContext/strings'

/**
 * Builds a valid product id for 7now endpoints
 * @param {String} slin
 * @param {String} ipq Default value '1'
 * @param {String} flavor_id Default value '0'
 * @param {String} size_index Default value '1'
 * @param {String} size_group Default value '0'
 * @returns {String} `${slin}-${size_index}-${size_group}-${ipq}-${flavor_id}`
 */
export const buildProductId = (
    slin = 'XXXXXX',
    ipq = 'X',
    flavor_id = 'X',
    size_index = '1',
    size_group = '0'
) => {
    return `${slin.padEnd(6, 'X')}-${size_index}-${size_group}-${ipq}-${flavor_id}`
}

// TODO: Remove once 'GET by ID' endpoint is implemented
export const formatProductImportBody = body => {
    delete body.__v
    delete body._id
    delete body.created_at
    delete body.last_sync_at
    delete body.product_id
    delete body.status
    delete body.updated_at
    delete body.size_index
}

export const formatInventoryImportBody = body => {
    //Required
    body.action = body.action.toLowerCase()
    body.price = parseInt(body.price)

    //Optional
    if (body.store_quantity) body.store_quantity = parseInt(body.store_quantity)
}

export const formatStoreImportBody = body => {
    body.action = body.action.toLowerCase()
    if (body.lat) body.lat = parseFloat(body.lat)
    if (body.lon) body.lon = parseFloat(body.lon)
}

//Receives body object and throws error if required fields are missing
export const checkRequiredFields = (body, requiredFields, errorMessage) => {
    //Using toString().length to check numbers as well as strings
    const badFields = requiredFields.filter(({ key }) => _.isNil(body[key]))

    //Throw error if fields are missing
    if (badFields.length) {
        const errorToThrow = new Error('Required Fields Missing')
        errorToThrow.customMessage = `${errorMessage}: ${badFields.map(field => ' ' + field.title)}`
        throw errorToThrow
    }
}

export const formatStoreImportState = async storeState => {
    //Clear unnecessary attributes before setting state
    delete storeState._id
    delete storeState.status
    delete storeState.updated_at
    delete storeState.last_sync_at
    delete storeState.created_at

    //Clear null fields and set the state
    for (let key in storeState) {
        if (storeState[key] === null) delete storeState[key]
    }

    return storeState
}

export const formatInventoryImportState = inventoryState => {
    //Clear unnecessary attributes before setting state
    delete inventoryState._id
    delete inventoryState.status
    delete inventoryState.updated_at
    delete inventoryState.last_sync_at
    delete inventoryState.created_at

    //Clear null fields and set the state
    for (let key in inventoryState) {
        if (inventoryState[key] === null) delete inventoryState[key]
    }

    return inventoryState
}

export const hasLocalizations = (localizations, fieldKey) => {
    let localizedLanguages = []

    for (let lang in localizations) {
        if (localizations[lang][fieldKey]) {
            localizedLanguages.push(lang.toUpperCase())
        }
    }

    return localizedLanguages
}

export const localizationsPreview = (localizations, fieldKey) => {
    const localizedLanguages = hasLocalizations(localizations, fieldKey)

    return localizedLanguages.length
        ? formatString('LOCALIZATIONS_PREVIEW', {
              localizedLanguages: localizedLanguages.join(', '),
          })
        : strings.LOCALIZATIONS_NOT_FOUND
}

export const mapDetailObject = (response, dictionary, initalState) => {
    const tempResponse = {}
    for (const propName in dictionary) {
        tempResponse[propName] = response[dictionary[propName]]
        delete response[dictionary[propName]]
        if (tempResponse[propName] === undefined) {
            tempResponse[propName] = initalState[propName]
        }
    }
    return tempResponse
}
